import { useEffect } from 'react';

import { useGetAiPromptsQuery } from '@app/api/AiPrompts';
import { useUserPrint } from '@app/hooks';
import type { TAiPromptsFormValues } from '@app/pages/AiPromptsSettings/types';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';

import type { FormInstance } from 'antd';

type UseAiPromptsSettingsEffectsParams = {
  form: FormInstance<TAiPromptsFormValues>;
};

export const useAiPromptsSettingsEffects = ({
  form,
}: UseAiPromptsSettingsEffectsParams) => {
  const { activeBranchId: ActiveBranchId } = useUserPrint();
  const { showNotification } = useNotification();

  const {
    data,
    isLoading: isDataLoading,
    error,
  } = useGetAiPromptsQuery({ ActiveBranchId }, { skip: !ActiveBranchId });

  useEffect(() => {
    if (error) {
      showNotification(handleCatchError(error));
    }
  }, [error, showNotification]);

  useEffect(() => {
    if (!data) return;

    const values = data.reduce<TAiPromptsFormValues>((acc, prompt) => {
      if (prompt.Key) {
        acc[prompt.Key] = prompt.Content ?? '';
      }
      return acc;
    }, {});

    form.setFieldsValue(values);
  }, [data, form]);

  return { data, isDataLoading, ActiveBranchId };
};
